<template>
  <div class="detection-status-bar-wrap" :style="style">
    <div class="detection-status-bar">
      <div class="left">
        <div v-if="left">
          <img :src="imgs.clock" :style="iconStyle" />
        </div>
      </div>
      <div class="center" v-if="center">
        <img :src="imgs.warning" :style="iconStyle" />
        <span :style="fontStyle">请不要将激光指向人</span>
      </div>
      <div class="right">
        <div>
          <img v-if="right" :src="imgs.link" :style="iconStyle" />
          <img v-else :src="imgs.closed" :style="iconStyle" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { assets } from '@/components/virtualPhone/utils';

export default {
  props: {
    center: {
      type: Boolean,
      default: true
    },
    left: {
      type: Boolean,
      default: true
    },
    right: {
      type: Boolean,
      default: true
    }
  },
  inject: ['calc'],
  data() {
    return {
      imgs: {
        clock: assets({ icon: 'clock', dir: '/detect' }),
        link: assets({ icon: 'link2', dir: '/detect' }),
        closed: assets({ icon: 'closed', dir: '/detect' }),
        warning: assets({ icon: 'warning', dir: '/detect' })
      }
    };
  },
  computed: {
    style() {
      return {
        height: this.calc(114, 'px'),
        marginBottom: this.calc(35, 'px'),
        padding: `0 ${this.calc(45, 'px')}`
      };
    },
    iconStyle() {
      return {
        width: this.calc(38, 'px'),
        height: this.calc(38, 'px')
      };
    },
    fontStyle() {
      return {
        fontSize: this.calc(30, 'px'),
        marginLeft: this.calc(10, 'px')
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.detection-status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  img {
    vertical-align: bottom;
  }
  span {
    color: #f4f4f4;
  }
}
</style>
